export interface IOptions {
    showUID: boolean;
    showRatios: boolean;
    showCover: boolean;
    showTOC: boolean;
    showNotesInDetailInToc: boolean;
    showCompanyInfos: boolean;
    showShareholderInfo: boolean;
    disableBalanceSheetPageBreak: boolean;
    displayAssetsAndLiabilitiesInSamePage: boolean;
    printClosingValueTotalsInSeparateColumn?: boolean;
    textColor: string;
    titleColor: string;
    highlightColor: string;
    backgroundColorPY: string;
    tableHeaderColor: string;
    tableFooterColor: string;
    showReportCompanyLogo: boolean;
    // Intern toggle
    showAdjustmentInSums: boolean;
    internalLabel: string | null;
    showRoundingDisclaimer: boolean;
    showAccounts: boolean;
    repeatAppendixTitle: boolean;
    isSealed: boolean;
    showPageNumbers: boolean;
}
